import React from "react";

const Blogs = React.lazy(()=>import('./Blogs'));
const BlogOne=React.lazy(()=>import('./BlogOne/BlogOne'));
const BlogTwo=React.lazy(()=>import('./BlogTwo/BlogTwo'));
const BlogThree=React.lazy(()=>import('./BlogThree/BlogThree'));
const BlogFour= React.lazy(()=>import('./BlogFour/BlogFour'));
const BlogFive=React.lazy(()=>import('./BlogFive/BlogFive'));
const BlogSix=React.lazy(()=>import('./BlogSix/BlogSix'));
const BlogSeven=React.lazy(()=>import('./BlogSeven/BlogSeven'));
const BlogEight=React.lazy(()=>import('./BlogEight/BlogEight'));
const BlogNine=React.lazy(()=>import('./BlogNine/BlogNine'));
const PanelBlog=React.lazy(()=>import('./AddArticle/PanelBlog'));

export {
    Blogs,
    BlogOne,
    BlogTwo,
    BlogThree,
    BlogFour,
    BlogFive,
    BlogSix,
    BlogSeven,
    BlogEight,
    BlogNine,
    PanelBlog
}